import { apiUrl } from '../constants/global';
import { getLoggedUser } from '../state/user';
import axios from 'axios';

const maskClasses = {
  D: 'Diamond',
  G: 'Gold',
};

const endpoint = `${apiUrl}groups`;
const user = getLoggedUser();

async function createGroup(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(endpoint, payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function getAllGroups(q) {
  const queryString = new URLSearchParams(q).toString();
  return fetch(`${endpoint}?${queryString}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.token}`,
    },
  }).then((data) => data.json());
}

async function getGroupsList(q) {
  const query = new URLSearchParams(q).toString();
  return fetch(`${apiUrl}v2/groups/list?${query}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function updateProjectCode(groupId, payload) {
  return fetch(`${endpoint}/project-code/${groupId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.token}`,
    },
    body: JSON.stringify(payload),
  }).then((res) => res.json());
}


// async function getAllPublicGroups(q) {
//   return fetch(`${apiUrl}groups/public` + '?' + q, {
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json',
//       Authorization: 'Bearer ' + user.token,
//     },
//   }).then((data) => data.json());
// }

async function getGroup(id) {
  return fetch(endpoint + '/' + id, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function updateGroup(payload, id) {
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(endpoint + '/' + id, payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

function deleteGroup(id) {
  return fetch(endpoint + '/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function getGroupsByTypes(type, subType) {
  return fetch(`getGroups/${type}/${subType}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      //Authorization: "Bearer " + user.token,
    },
  }).then((data) => data.json());
}

async function getEnrolledGroups(q) {
  return fetch(apiUrl + `groups_enrolled?${q}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function getAllEndedGroups() {
  return fetch(`${apiUrl}ended_groups`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function getCompletedGroups(q = '') {
  return fetch(apiUrl + `completed_auction_groups?${q}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

export {
  createGroup,
  getAllGroups,
  getGroup,
  updateGroup,
  deleteGroup,
  getGroupsByTypes,
  getEnrolledGroups,
  getAllEndedGroups,
  getCompletedGroups,
  updateProjectCode,
  getGroupsList ,
  // getAllPublicGroups,
  maskClasses,
};
